// @ts-nocheck
import { css } from 'styled-components';

export const sizes = {
  desktop: 992,
  tablet: 768,
  phone: 480,
};

export const media = Object.keys(sizes).reduce((accumulator, label) => {
  const emSize = sizes[label] / 16;
  accumulator[label] = (...args: string[]) => css`
    @media (min-width: ${emSize}em) {
      ${css(...args)};
    }
  `;
  return accumulator;
}, {});
